export function getNestedValue(obj, path) {
  return String(path).split('.').reduce((acc, part) => {
    return acc && acc[part] !== undefined ? acc[part] : undefined;
  }, obj);
}

